// loader.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loading = false;

  start() {
    this.loading = true;
  }

  complete() {
    this.loading = false;
  }

  isLoading(): boolean {
    return this.loading;
  }
}
